import Vue from 'vue'
import App from './App.vue'
import router from './router'; // 导入 Vue Router 路由
import store from './store';
import 'normalize.css/normalize.css';
import 'element-ui/lib/theme-chalk/index.css'; // 引入element ui 样式
import Element from 'element-ui'; // 导入 Element UI 组件库
Vue.use(Element, { size: 'small' }); // 使用 Element UI，并设置默认组件尺寸为 small


Vue.config.productionTip = false


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
});
